import withDraft from '@/utils/draftHelper';
import actions from '../constants';

const applyWebSocket = withDraft((draft, action) => { draft.websocket.host = action.websocket; });

export default {
  [actions.APPLY_WEBSOCKET]: applyWebSocket,
};
